/* eslint-disable import/no-duplicates */
import { faAngleDown as AngleDownRegular } from '@fortawesome/pro-regular-svg-icons';
import { faCogs as CogsRegular } from '@fortawesome/pro-regular-svg-icons';
import { faUsdSquare as DollarSquareRegular } from '@fortawesome/pro-regular-svg-icons';
import { faEnvelopeOpenText as EnvelopeOpenRegular } from '@fortawesome/pro-regular-svg-icons';
import { faHome as HomeRegular } from '@fortawesome/pro-regular-svg-icons';
import { faFileImport as ImportRegular } from '@fortawesome/pro-regular-svg-icons';
import { faPlus as PlusRegular } from '@fortawesome/pro-regular-svg-icons';
import { faSearch as SearchRegular } from '@fortawesome/pro-regular-svg-icons';
import { faTag as TagRegular } from '@fortawesome/pro-regular-svg-icons';
import { faUsers as UsersRegular } from '@fortawesome/pro-regular-svg-icons';
import { faUsersCrown as UsersAdminRegular } from '@fortawesome/pro-regular-svg-icons';
import { faArrowLeft as LeftArrow } from '@fortawesome/pro-regular-svg-icons';
import { faArrowRight as RightArrow } from '@fortawesome/pro-regular-svg-icons';
import { faCheckCircle as CheckCircleSolid } from '@fortawesome/free-solid-svg-icons';
import { faHistory as HistorySolid } from '@fortawesome/free-solid-svg-icons';
import { faLink as LinkSolid } from '@fortawesome/free-solid-svg-icons';
import { faBars as MenuSolid } from '@fortawesome/free-solid-svg-icons';
import { faMobileAlt as MobileSolid } from '@fortawesome/free-solid-svg-icons';
import { faPaperPlane as PaperPlaneSolid } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle as TimesCircleSolid } from '@fortawesome/free-solid-svg-icons';
import { faCommentAltDots as CommentSolid } from '@fortawesome/pro-solid-svg-icons';
import { faUsdSquare as DollarSquareSolid } from '@fortawesome/pro-solid-svg-icons';
import { faPaperPlane as PaperPlaneRegular } from '@fortawesome/free-regular-svg-icons';
import { faSignOut as SignOut } from '@fortawesome/pro-regular-svg-icons';
import { faUpload as UploadRegular } from '@fortawesome/pro-regular-svg-icons';
import { faExclamationTriangle as Warning } from '@fortawesome/free-solid-svg-icons';
import { faUserCrown as SuperAdmin } from '@fortawesome/pro-regular-svg-icons';
import { faCalendarDay as Calendar } from '@fortawesome/pro-light-svg-icons';
import { faCreditCard as CreditCardBack } from '@fortawesome/pro-light-svg-icons';
import { faCreditCardFront as CreditCardFront } from '@fortawesome/pro-light-svg-icons';
import { faFileExcel as FileExcel } from '@fortawesome/pro-light-svg-icons';
import { faSort as Sort } from '@fortawesome/pro-light-svg-icons';
import { faSortUp as SortUp } from '@fortawesome/pro-light-svg-icons';
import { faSortDown as SortDown } from '@fortawesome/pro-light-svg-icons';
import { faSms as SmsRegular } from '@fortawesome/pro-regular-svg-icons';
import { faImagePolaroid as GalleryRegular } from '@fortawesome/pro-regular-svg-icons';
import { faTrashAlt as DeleteSolid } from '@fortawesome/pro-solid-svg-icons';
import { faEdit as EditRegular } from '@fortawesome/pro-regular-svg-icons';
import { faCopy as CopyRegular } from '@fortawesome/pro-regular-svg-icons';
import { faLongArrowLeft as BackArrorwRegular } from '@fortawesome/pro-regular-svg-icons';
import { faClock as ClockRegular } from '@fortawesome/pro-regular-svg-icons';
import { faEye as EyeRegular } from '@fortawesome/pro-regular-svg-icons';
import { faInfoCircle as infoRegular } from '@fortawesome/pro-regular-svg-icons';
import { faAngleRight as RightArrowRegular } from '@fortawesome/pro-regular-svg-icons';
import { faBinoculars as Binoculars } from '@fortawesome/pro-regular-svg-icons';
import { faFilter as FilterList } from '@fortawesome/pro-regular-svg-icons';
import { faCompass as CompassRegular } from '@fortawesome/pro-regular-svg-icons';
import { faGrinStars as GrinStarsSolid, faTh as TableCells } from '@fortawesome/free-solid-svg-icons';

export const IconEnum = {
  Calendar,
  CreditCardBack,
  CreditCardFront,
  RightArrow,
  SuperAdmin,
  UploadRegular,
  AngleDownRegular,
  CogsRegular,
  DollarSquareRegular,
  EnvelopeOpenRegular,
  HomeRegular,
  ImportRegular,
  PlusRegular,
  SearchRegular,
  TagRegular,
  UsersRegular,
  UsersAdminRegular,
  LeftArrow,
  CheckCircleSolid,
  HistorySolid,
  LinkSolid,
  MenuSolid,
  MobileSolid,
  PaperPlaneSolid,
  TimesCircleSolid,
  CommentSolid,
  DollarSquareSolid,
  PaperPlaneRegular,
  SignOut,
  Warning,
  FileExcel,
  Sort,
  SortUp,
  SortDown,
  SmsRegular,
  GalleryRegular,
  DeleteSolid,
  EditRegular,
  CopyRegular,
  BackArrorwRegular,
  ClockRegular,
  EyeRegular,
  infoRegular,
  RightArrowRegular,
  Binoculars,
  FilterList,
  CompassRegular,
  TableCells,
  GrinStarsSolid,
};
